import { Box } from '@components/ui/atoms/Box';
import { Text } from '@components/ui/atoms/Text';
import { useServiceWorker } from '@shared/serviceWorker';

export const OfflineIndicator = () => {
    const { isOffline } = useServiceWorker();

    if (!isOffline) {
        return null;
    }

    return (
        <Box
            position="fixed"
            top="0"
            left="0"
            right="0"
            zIndex="9998"
            bg="orange.500"
            color="white"
            p="3"
            textAlign="center"
        >
            <Text fontWeight="semibold" mb="1">
                You are offline!
            </Text>
            <Text fontSize="sm">
                Some features may be limited as you are currently offline. Changes will be synced when you are back online.
            </Text>
        </Box>
    );
};
